import { render, staticRenderFns } from "./AthleteAccordionSettings.vue?vue&type=template&id=15670ace&scoped=true&"
import script from "./AthleteAccordionSettings.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccordionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15670ace",
  null
  
)

export default component.exports